import {
    GET_GROUP,
    SET_GROUP_SKELETON,
    SET_GROUP_LOADING,
    REMOVE_GROUP_LOADING,
    SET_GROUP_DROPDOWN,
    SET_GROUP_MODULE_NAME
} from "../../types";

import axios from "axios";

import { handleError } from "../error";
import { handleResponse } from "../response";

/**
 * @name	getGroup
 * @param 	{*} id, component
 */

// DESC: Method setup to be trigger when groups add first load. This is go out and get all the data needed to render add view.
export const getGroup = (id, component) => async(dispatch) => {
    try {
        dispatch({ type: SET_GROUP_LOADING });

        const result = await axios.get(`/groups/view/${id}?reactAPI=true`);
        // console.log(result);
        dispatch(handleResponse(result));
        let group_fields = result.data.group;

        const res = await axios.get(`/skeleton?view=${component}`);
        dispatch(handleResponse(res));
        await dispatch({
            type: SET_GROUP_SKELETON,
            payload: res.data.skeleton
        });

        // let section_fields =
        //     res.data.skeleton.tabs[0].tab_sections[0][0].section_fields;
        // console.log(section_fields);
        // for (const [secsection_field_key, section_field] of Object.entries(
        //     section_fields
        // )) {
        //     // console.log(section_field_value);
        //     for (const [field_key, field] of Object.entries(section_field)) {
        //         let disabledOnVerb = JSON.parse(
        //             field.disabled_on_verb
        //         ).includes(verb);

        //         if (!disabledOnVerb) {
        //             // console.log(field);
        //             if (
        //                 field.name === "asset_reassignment" ||
        //                 field.name ===
        //                     "asset_reassignment_client_account_officer"
        //             ) {
        //                 group_fields[field.name] = "none";
        //             }
        //         }
        //     }
        // }
        result.data.group = group_fields;
        group_fields.properties = result.data.properties;
        group_fields.contracts = result.data.contracts;
        group_fields.associated_contracts = result.data.associated_contracts;
        group_fields.asset_reassignment = "none";
        group_fields.asset_reassignment_client_account_officer = "none";
        await dispatch({
            type: GET_GROUP,
            payload: group_fields
        });
        // console.log(group_fields);

        let dropdowns = result.data;
        if (dropdowns.property_operation_managers) {
            dropdowns.property_operation_managers.map(
                (property_operation_manager) => {
                    property_operation_manager.first_name =
                        property_operation_manager.first_name +
                        " " +
                        property_operation_manager.last_name;
                }
            );
        }

        if (dropdowns.current_property_operations_manager) {
            let current_property_operations_manager_select = [
                {
                    name: "No reassignment",
                    value: "none"
                },
                {
                    name: "Assets previously assigned to " +
                        dropdowns.current_property_operations_manager.first_name +
                        " " +
                        dropdowns.current_property_operations_manager.last_name,
                    value: "some"
                },
                {
                    name: "All assets in this group",
                    value: "all"
                }
            ];
            dropdowns.current_property_operations_manager_select = current_property_operations_manager_select;
        }
        else {
            let current_property_operations_manager_select = [
                {
                    name: "No reassignment",
                    value: "none"
                },
                {
                    name: "All assets in this group",
                    value: "all"
                }
            ];
            dropdowns.current_property_operations_manager_select = current_property_operations_manager_select;
        }

        if (dropdowns.current_client_account_officer) {
            let current_client_account_officer_select = [
                {
                    name: "No reassignment",
                    value: "none"
                },
                {
                    name: "Assets previously assigned to " +
                        dropdowns.current_client_account_officer.first_name +
                        " " +
                        dropdowns.current_client_account_officer.last_name,
                    value: "some"
                },
                {
                    name: "All assets in this group",
                    value: "all"
                }
            ];
            dropdowns.current_client_account_officer_select = current_client_account_officer_select;
        }
        else {
            let current_client_account_officer_select = [
                {
                    name: "No reassignment",
                    value: "none"
                },
                {
                    name: "All assets in this group",
                    value: "all"
                }
            ];
            dropdowns.current_client_account_officer_select = current_client_account_officer_select;
        }

        if (dropdowns.client_account_officers) {
            dropdowns.client_account_officers.map(
                (client_account_officer) => {
                    client_account_officer.first_name =
                        client_account_officer.first_name +
                        " " +
                        client_account_officer.last_name;
                }
            );
        }
        // console.log(dropdowns);

        await dispatch({
            type: SET_GROUP_DROPDOWN,
            payload: dropdowns
        });

        dispatch({ type: REMOVE_GROUP_LOADING });
    }
    catch (error) {
        handleError(error);
    }
};

/**
 * @name	getAddGroups
 * @param 	{*} component
 */
// DESC: Method setup to be trigger when groups add first load. This is go out and get all the data needed to render add view.
export const getGroupAdd = component => async(dispatch, getState) => {
    try {
        dispatch({ type: SET_GROUP_LOADING });
        const { MISC: { APP: { ROUTE: { verb } } } } = getState();

        const res = await axios.get(`/skeleton?view=${component}`);
        dispatch(handleResponse(res));
        let skeleton = res.data.skeleton;
        await dispatch({
            type: SET_GROUP_SKELETON,
            payload: skeleton
        });

        let group_fields = {};
        let section_fields = skeleton.tabs[0].tab_sections[0][0].section_fields;
        // console.log(section_fields);
         
        for (const [secsection_field_key, section_field] of Object.entries(
            section_fields
        )) {
            // console.log(section_field_value);
             
            for (const [field_key, field] of Object.entries(section_field)) {
                let disabledOnVerb = JSON.parse(
                    field.disabled_on_verb
                ).includes(verb);

                if (!disabledOnVerb) {
                    // console.log(field);
                    group_fields[field.name] = "";
                }
            }
        }
        // console.log(group_fields);

        // console.log(group_fields);
        await dispatch({
            type: GET_GROUP,
            payload: group_fields
        });

        const result = await axios.get(`/groups/add?reactAPI=true`);
        dispatch(handleResponse(result));

        //	DESC: If status not equal to 200, throw error with response text from backend
        if (result.status !== 200) {
            throw new Error(result.responseText);
        }

        let dropdowns = result.data;
        if (dropdowns.property_operation_managers) {
            dropdowns.property_operation_managers.map(
                (property_operation_manager) => {
                    property_operation_manager.first_name =
                        property_operation_manager.first_name +
                        " " +
                        property_operation_manager.last_name;
                }
            );
        }

        if (dropdowns.current_property_operations_manager) {
            let current_property_operations_manager_select = [
                {
                    name: "Assets previously assigned to " +
                        dropdowns.current_property_operations_manager.first_name +
                        " " +
                        dropdowns.current_property_operations_manager.last_name,
                    value: "some"
                },
                {
                    name: "All assets in this group",
                    value: "all"
                }
            ];
            dropdowns.current_property_operations_manager_select = current_property_operations_manager_select;
        }

        if (dropdowns.client_account_officers) {
            dropdowns.client_account_officers.map(
                (client_account_officer) => {
                    client_account_officer.first_name =
                        client_account_officer.first_name +
                        " " +
                        client_account_officer.last_name;
                }
            );
        }
        // console.log(dropdowns);

        await dispatch({
            type: SET_GROUP_DROPDOWN,
            payload: dropdowns
        });

        dispatch({ type: REMOVE_GROUP_LOADING });
    }
    catch (error) {
        handleError(error);
    }
};

/**
 * @name	updateGroupData
 * @param 	{*} event
 */
// DESC: Method setup to be trigger when groups data changed. it would update the props based on event type.
export const updateGroupData = event => async(dispatch, getState) => {
    try {
        event.persist();

        const { groups: { groupData } } = getState();

        let { type } = event.target;

        switch (type) {
            case "text":
                groupData[event.target.name] = event.target.value;

                await dispatch({
                    type: GET_GROUP,
                    payload: { ...groupData }
                });
                break;
            case "select-one":
                if (isNaN(event.target.value)) {
                    groupData[event.target.name] = event.target.value;
                }
                else if (event.target.value === "") {
                    groupData[event.target.name] = event.target.value;
                }
                else {
                    groupData[event.target.name] = parseInt(event.target.value);
                }
                await dispatch({
                    type: GET_GROUP,
                    payload: { ...groupData }
                });
                break;
            case "date":
                groupData[event.target.name] = event.target.value;
                await dispatch({
                    type: GET_GROUP,
                    payload: { ...groupData }
                });
                break;
            case "checkbox": {
                let index = groupData.associated_contracts.indexOf(
                    parseInt(event.target.value)
                );
                if (index > -1) {
                    groupData.associated_contracts.splice(index, 1);
                }
                else {
                    groupData.associated_contracts.push(
                        parseInt(event.target.value)
                    );
                }
                await dispatch({
                    type: GET_GROUP,
                    payload: { ...groupData }
                });
                break;
            }
            default:
                break;
        }
        return true;
    }
    catch (error) {
        handleError(error);
        return 500;
    }
};

/**
 * @name	submitGroup
 * @param 	{*} event, verb
 */
// DESC: Method setup to be trigger when group submit clicked on both add and update.
export const submitGroup = (event) => async(dispatch, getState) => {
    try {
        event.persist();
        event.target.disabled = true;
        dispatch({ type: SET_GROUP_LOADING });

        const {
            groups: { groupData, groupSkeleton },
            MISC: { APP: { ROUTE: { verb } } }
        } = getState();
        // delete groupData.date;
        // let postData = groupData;
        let postData = {};
        postData.reactAPI = true;
        // console.log(groupData);
        let section_fields =
            groupSkeleton.tabs[0].tab_sections[0][0].section_fields;
         
        for (const [secsection_field_key, section_field] of Object.entries(
            section_fields
        )) {
             
            for (const [field_key, field] of Object.entries(section_field)) {
                let disabledOnVerb = JSON.parse(
                    field.disabled_on_verb
                ).includes(verb);

                if (!disabledOnVerb) {
                    // console.log(groupData.group[field.name]);
                    if (
                        groupData[field.name] === "" ||
                        groupData[field.name] === undefined
                    ) {
                        // console.log(groupData.group[field.name]);
                        throw new Error("All fields are required");
                    }
                    else {
                        postData[field.name] = groupData[field.name];
                    }
                }
            }
        }
        // console.log(postData);

        // Setup the post data
        // let postData = {
        //     reactAPI: true,
        //     code: groupData.group["code"],
        //     name: groupData.group["name"],
        //     default_property_operations_manager:
        //         groupData.group["default_property_operations_manager"],
        //     default_client_account_officer:
        //         groupData.group["default_client_account_officer"]
        // };
        // if (verb === "edit") {
        //     postData.asset_reassignment = groupData.group["asset_reassignment"];
        //     postData.asset_reassignment_client_account_officer =
        //         groupData.group["asset_reassignment_client_account_officer"];
        // }

        // console.log(postData);

        // Object.entries(group_fields).forEach(([key, value]) => {
        //     postData[key] = value;
        // });

        let postUrl = "";
        if (verb === "add") {
            postUrl = "/groups/add/";
        }
        else {
            postData.contracts = groupData.associated_contracts;
            postUrl = "/groups/edit/" + groupData.id;
        }

        const response = await axios.post(postUrl, postData);
        // console.log(response);
        dispatch(handleResponse(response));
        await dispatch({ type: REMOVE_GROUP_LOADING });
        event.target.disabled = false;
    }
    catch (error) {
        console.log(error);
        dispatch(handleError(error));

        event.target.disabled = false;
        dispatch({ type: REMOVE_GROUP_LOADING });
    }
};

export const getGroupModuleName = () => async(dispatch) => {
    try {
        const result = await axios.get(`/groups/moduleName`);

        dispatch(handleResponse(result));

        await dispatch({
            type: SET_GROUP_MODULE_NAME,
            payload: result.data
        });
    }
    catch (error) {
        handleError(error);
    }
};